import Backbone from '@polleverywhere/backbone'
import Report from '@polleverywhere/core/lib/models/report'
import URI from 'urijs'
import ErrorModel from '../../models/error'
import Skeleton from '../../models/skeleton'
import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

function updateRoute () {
  const { page } = store.getState()[appSlice.name]
  if (page !== 'reports') {
    return
  }

  const route = computePath(this.appState)

  if (route) {
    this.navigate(route, { trigger: false })
  }
}

function computePath (state) {
  const report = state.get('report')

  if (report) {
    if (report instanceof ErrorModel) {
      return undefined
    } else if (report instanceof Skeleton && !report.id) {
      return undefined
    }

    return URI('reports').segment(report.id.toString()).toString()
  } else {
    const pageNumber = state.get('pageNumber')
    let uri = URI('reports')

    if (pageNumber > 1) {
      uri = uri.query({ page: pageNumber })
    }

    return uri.toString()
  }
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      'reports/:id': (id) => {
        store.dispatch(appSlice.pageUpdated('reports'))

        const report = new Report({ id })
        this.appState.changeReport(report)

        report.fetch()
          .fail((error) => {
            this.appState.set({
              report: new ErrorModel({ code: error.status }),
              action: 'view'
            })
          })
      },
      'reports(?page=:pageNumber)': (pageNumber) => {
        this.appState.showHome(parseInt(pageNumber) || 1)
        store.dispatch(appSlice.pageUpdated('reports'))
      }
    }
  }

  // TODO: figure out why specs need this
  set routes (_) {}

  initialize (options = {}) {
    _.defaults(options, {
      updateURL: true
    })

    this.appState = options.state.appStates.reporting

    // Update route based on state changes
    if (!options.updateURL) {
      return
    }

    // Listen to redux change
    store.subscribe(updateRoute.bind(this))

    // Wire up Activities state changes to the browser url
    this.listenTo(this.appState, 'change', updateRoute.bind(this))
  }
}
